var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.17,59.28c-15.7,0-27.54,13.27-27.54,30.87S90.44,121,106.09,121c6.53,0,14.81-2.78,14.81-5.92,0-.54-.14-3.27-2.93-3.27a3.54,3.54,0,0,0-1.52.41,20.63,20.63,0,0,1-10.19,2.92c-12.16,0-21.34-10.79-21.34-25.09s9.14-24.93,21.25-24.93,21.34,10.72,21.34,24.93c0,4.51-.54,9.11-4.59,9.11-2,0-4.16-1.49-4.16-4.76V77.93a2.43,2.43,0,0,0-2.59-2.67,2.55,2.55,0,0,0-2.45,1.55l-.38,1.55-1.23-1a9.73,9.73,0,0,0-6.45-2.07c-9.06,0-13.18,7.76-13.18,15,0,7.57,4.53,15.23,13.18,15.23a10.78,10.78,0,0,0,8.57-3.68l.82-.93.74,1a9.34,9.34,0,0,0,7.56,3.35c6.64,0,10.45-5.53,10.45-15.15C133.8,72.51,121.92,59.28,106.17,59.28Zm-.51,40.42c-4.45,0-7.32-3.65-7.32-9.29,0-6.92,3.94-9.38,7.32-9.38S113,83.49,113,90.41C113,96.05,110.11,99.7,105.66,99.7Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "180.74 90.11 180.74 186.71 33.74 186.71 33.74 90.11"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "33.74 90.11 109.34 153.95 180.74 90.11"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 180.74,
    y1: 186.71,
    x2: 130.34,
    y2: 135.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 33.74,
    y1: 186.71,
    x2: 88.34,
    y2: 137.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 56.23,
    y1: 68.86,
    x2: 33.74,
    y2: 88.98
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "124.05 40.9 105.14 25.14 88.38 40.12"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 180.74,
    y1: 88.98,
    x2: 158.26,
    y2: 70.55
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "158.26 109 158.26 41.23 57.26 41.23 57.26 109"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/EMAIL.b0f03cd5d5188ec35dd1850a25c90aa1.svg";
export { ForwardRef as ReactComponent };